// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1FVlw","title":"AfterBackImages_title__yN19h","images":"AfterBackImages_images__2Wt2r"};